module.exports = __webpack_public_path__ + "static/media/kuaraDescription.cd3fe555.svg";